var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457",
    transform: "translate(-1193 -360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question-circle-Filled_1_",
    d: "M278,2555a25,25,0,1,0,25,25A25.041,25.041,0,0,0,278,2555Z",
    transform: "translate(940 -2195)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(1206 373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "question-circle-Filled_1_2",
    "data-name": "question-circle-Filled_1_",
    d: "M270.5,2555a17.5,17.5,0,1,0,17.5,17.5A17.529,17.529,0,0,0,270.5,2555Zm0,28a1.75,1.75,0,1,1,1.75-1.749A1.754,1.754,0,0,1,270.5,2583Zm3.57-8.189c-1.61,1.068-1.872,1.645-1.907,1.75a1.744,1.744,0,0,1-1.663,1.19,2.074,2.074,0,0,1-.56-.087,1.776,1.776,0,0,1-1.1-2.222,8.025,8.025,0,0,1,3.29-3.553c2.187-1.453,1.907-3.028,1.82-3.535a3.55,3.55,0,0,0-2.8-2.8A3.506,3.506,0,0,0,267,2569a1.75,1.75,0,1,1-3.5,0,6.968,6.968,0,0,1,2.5-5.354,6.992,6.992,0,0,1,11.393,4.095A6.837,6.837,0,0,1,274.07,2574.81Z",
    transform: "translate(948 -2187)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.daaded044f9b6da13d19934e410c9a29.svg";
export { ForwardRef as ReactComponent };